import React from 'react';
import { Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';

import CompleteDocumentClaim from '@bizapp-lp/pjr/pages/CompleteDocumentClaim';
import CompleteContact from '@bizapp-lp/pjr/pages/CompleteContact';
import CompleteTrialApplication from '@bizapp-lp/pjr/pages/CompleteTrialApplication';
import Contact from '@bizapp-lp/pjr/pages/Contact';
import DocumentClaim from '@bizapp-lp/pjr/pages/DocumentClaim';
import Invalid from '@bizapp-lp/pjr/pages/Invalid';
import ServiceSpec from '@bizapp-lp/pjr/pages/ServiceSpec';
import ServiceSpec02 from '@bizapp-lp/pjr/pages/specs/ServiceSpec0220211015';
import ServiceSpec03 from '@bizapp-lp/pjr/pages/specs/ServiceSpec0320220328';
import ServiceSpec04 from '@bizapp-lp/pjr/pages/specs/ServiceSpec0420220627';
import ServiceSpec05 from '@bizapp-lp/pjr/pages/specs/ServiceSpec0520230401';
import TrialApplication from '@bizapp-lp/pjr/pages/TrialApplication';
import TrialSpec from '@bizapp-lp/pjr/pages/TrialSpec';
import TrialSpec01 from '@bizapp-lp/pjr/pages/specs/TrialSpec0120211015';
import TrialSpec02 from '@bizapp-lp/pjr/pages/specs/TrialSpec0220220328';

import DocumentForZoom from '@bizapp-lp/pjr/pages/internal/DocumentForZoom';
import Sitemap from '@bizapp-lp/pjr/pages/internal/Sitemap';

import { theme } from '@bizapp-lp/pjr/styles/theme';

const App: React.FC = () => {
  const { hash, pathname } = useLocation();
  const grecaptchaKey = process.env.REACT_APP_GRECAPTCHA_KEY ?? '';
  const API_BASE_URL = process.env.REACT_APP_API_EXTERNAL_BASE_URL ?? '';
  const marketoBaseUrl = process.env.REACT_APP_MARKETO_BASE_URL ?? '';
  const munchkinId = process.env.REACT_APP_MARKETO_MUNCHKIN_ID ?? '';
  const marketoFormContact = {
    baseUrl: marketoBaseUrl,
    munchkinId: munchkinId,
    formId: process.env.REACT_APP_PJR_MARKETO_CONTACT_FORM_ID ?? '',
  };
  const marketoFormDocumentClaim = {
    baseUrl: marketoBaseUrl,
    munchkinId: munchkinId,
    formId: process.env.REACT_APP_PJR_MARKETO_DOCUMENT_CLAIM_FORM_ID ?? '',
  };

  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [hash, pathname]);

  const Redirect: React.FC = () => {
    React.useEffect(() => {
      window.location.href = 'https://www.worksap.co.jp/saas/projectroom/';
    }, []);
    return <></>;
  };

  return (
    <ThemeProvider theme={theme}>
      <Routes basename="/pjr">
        <Route
          path="/complete-contact"
          element={<CompleteContact isAllowedDirectAccess />}
        />
        <Route
          path="/complete-trial-application"
          element={<CompleteTrialApplication />}
        />
        <Route
          path="/complete-document-claim"
          element={<CompleteDocumentClaim isAllowedDirectAccess />}
        />
        <Route
          path="/contact"
          element={
            <Contact
              grecaptchaKey={grecaptchaKey}
              marketoForm={marketoFormContact}
            />
          }
        />
        <Route
          path="/document-claim"
          element={
            <DocumentClaim
              grecaptchaKey={grecaptchaKey}
              marketoForm={marketoFormDocumentClaim}
            />
          }
        />
        <Route path="/invalid" element={<Invalid />} />
        <Route
          path="/trial-application"
          element={
            <TrialApplication
              grecaptchaKey={grecaptchaKey}
              apiBaseUrl={API_BASE_URL}
            />
          }
        />
        <Route path="/service-spec" element={<ServiceSpec />} />
        <Route
          path="/spec-archive"
          element={
            <>
              <Outlet />
            </>
          }
        >
          <Route path="/service-spec-02-20211015" element={<ServiceSpec02 />} />
          <Route path="/service-spec-03-20220328" element={<ServiceSpec03 />} />
          <Route path="/service-spec-04-20220627" element={<ServiceSpec04 />} />
          <Route path="/service-spec-05-20230401" element={<ServiceSpec05 />} />
          <Route path="/trial-spec-01-20211015" element={<TrialSpec01 />} />
          <Route path="/trial-spec-02-20220328" element={<TrialSpec02 />} />
        </Route>
        <Route path="/trial-spec" element={<TrialSpec />} />
        <Route path="/internal">
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/document-for-zoom" element={<DocumentForZoom />} />
          <Route path="*" element={<Sitemap />} />
          <Route path="" element={<Sitemap />} />
        </Route>
        <Route path="*" element={<Redirect />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
